<template>
  <div class="tc-container">
    <div class="tc-chart">
      <div ref="myChart" class="myChart"></div>
    </div>
  </div>
</template>
<script>
  export default {
    props: {
      item: {
        type: Object,
        default() {
          return {}
        },
      },
    },
    data() {
      return {
        colorList: [
          ['#0f1819', '#f07317'],
          ['#0d1719', '#f0de17'],
          ['#0d181a', '#17f08c'],
          ['#0d1619', '#17f0de'],
          ['#0d171a', '#17bff0'],
        ],
      }
    },
    mounted() {
      this.init()
    },
    methods: {
      init() {
        let that = this
        let chartDom = this.$refs.myChart
        let myChart = this.$echarts.init(chartDom)
        let option = (option = {
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'shadow',
            },
            formatter: '{b} : {c1} ',
          },
          grid: {
            top: '5%',
            left: '8%',
            right: '8%',
            bottom: '20%',
            containLabel: true,
          },
          xAxis: {
            type: 'value',
            axisLabel: {
              fontSize: 14,
              //给坐标名添加颜色属性
              textStyle: {
                color: '#ffffff',
              },
            },
            splitLine: {
              show: false,
            },
            axisLine: {
              show: false,
            },
            axisTick: {
              show: false,
            },
          },
          yAxis: {
            type: 'category',
            data: ['TOP.5 ae', 'TOP.4 ad', 'TOP.3 ac', 'TOP.2 ab', 'TOP.1 aa'],
            axisLabel: {
              fontSize: 14,
              //给坐标名添加颜色属性
              textStyle: {
                color: function (params, index) {
                  console.log('22121', index)
                  let colorList = [
                    '#FFFFFF',
                    '#FFFFFF',
                    '#02FFA3',
                    '#FFAE00',
                    '#FF0000',
                  ]
                  return colorList[index]
                },
              },
            },
            splitLine: { show: false },
            axisLine: {
              show: true,
            },
            axisTick: {
              show: false,
            },
            offset: 15,
            nameTextStyle: {
              fontSize: 15,
            },
          },
          series: [
            {
              type: 'bar',
              stack: '数量',
              itemStyle: {
                barBorderColor: 'rgba(0,0,0,0)',
                color: 'rgba(0,0,0,0)',
              },
              emphasis: {
                itemStyle: {
                  barBorderColor: 'rgba(0,0,0,0)',
                  color: 'rgba(0,0,0,0)',
                },
              },
              data: [1, 1, 1, 1, 1],
            },
            {
              name: '数量',
              stack: '数量',
              type: 'bar',
              data: [120, 160, 200, 240, 280],
              barWidth: 8,
              barGap: 10,
              smooth: true,
              label: {
                normal: {
                  show: false,
                },
              },
              itemStyle: {
                emphasis: {
                  barBorderRadius: 7,
                },
                normal: {
                  barBorderRadius: [0, 10, 10, 0],
                  color: function (params) {
                    let colorArr = [
                      ['#0f1819', '#f07317'],
                      ['#0d1719', '#f0de17'],
                      ['#0d181a', '#17f08c'],
                      ['#0d1619', '#17f0de'],
                      ['#0d171a', '#17bff0'],
                    ]
                    console.log(colorArr[params.dataIndex])
                    return new that.$echarts.graphic.LinearGradient(
                      0,
                      0,
                      1,
                      0,
                      [
                        { offset: 0, color: colorArr[params.dataIndex][0] },
                        { offset: 1, color: colorArr[params.dataIndex][1] },
                      ]
                    )
                  },
                },
              },
            },
          ],
        })
        myChart.setOption(option)
        window.addEventListener('resize', () => {
          myChart.resize()
        })
      },
    },
  }
</script>
<style lang="scss" scoped>
  .tc-container {
    width: 100%;

    .tc-chart {
      width: 100%;
      height: 11.458vw;
      margin: 0 auto;

      .myChart {
        width: 100%;
        height: 11.458vw;
      }
    }
  }
</style>
